export const babylonFont = require("../assets/babylon.woff");
